import { render } from "./BaseWrapper.vue?vue&type=template&id=5c0eec99"
import script from "./BaseWrapper.vue?vue&type=script&lang=js"
export * from "./BaseWrapper.vue?vue&type=script&lang=js"

import "./BaseWrapper.vue?vue&type=style&index=0&id=5c0eec99&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__